export default __webpack_public_path__ + "static/media/cardinal-color.add1432e.svg";